export const EMAILTEMPLATE_USAGEKEYSMAP = new Map([
  ["REG_CONFIRMATION", "Confirmation"],
  ["REG_MAGIC_LINK", "Magic Link"],
  ["FORGOT_PASSWORD", "Forgot Password"],
  ["REG_CANCELLATION", "Cancel"],
  ["REFUND", "Refund"],
  ["PAYMENT_LINK", "Payment Link"],
  ["REG_INVITE", "Registration Invite"],
]);

export const HIDDEN_EMAIL_USAGE_KEYS = [
  "REG_EMAIL_VALIDATION",
  "ADMIN_PASSWORD_SETUP",
  "ADMIN_FORGOT_PASSWORD",
  "REG_FORGOT_PASSWORD",
  "REFUND",
];

export const REGISTRATIONMESSAGES_MESSAGETYPEMAP = new Map([
  ["COMPLETION", "Registration Completion"],
]);

export const ZEROGUID = "00000000-0000-0000-0000-000000000000";
export const PLATFORM_ID = "Zvg38ROjwoafDKH0iqWmOZQHfOo38Vbz";

// Legacy hardcoded IDs — auth configs now use usage key lookups instead
export const PLATFORM_EMAIL_IDS = {
  SET_PASSWORD: "a9d8e7f6-5c4b-3a2d-1e0f-9a8b7c6d5e4f",
  RESET_PASSWORD: "f627cafc-2108-48f7-a2fc-21399951197e",
};

export type EmailVariable = { key: string; display: string };

export const EMAIL_VARIABLES_BY_TYPE: Record<string, EmailVariable[]> = {
  REG_CONFIRMATION: [
    { key: "EVENT_NAME", display: "Event Name" },
    { key: "ATTENDEE_NAME", display: "Attendee First Name" },
    { key: "ATTENDEE_FULL_NAME", display: "Attendee Full Name" },
    { key: "ATTENDEE_LAST_NAME", display: "Attendee Last Name" },
    { key: "CONFIRMATION_NUMBER", display: "Confirmation Number" },
    { key: "VENUE_NAME", display: "Venue Name" },
    { key: "VENUE_ADDRESS", display: "Venue Address" },
    { key: "REVIEW_PAGE_LINK", display: "Attendee Portal" },
  ],
  REG_MAGIC_LINK: [
    { key: "EVENT_NAME", display: "Event Name" },
    { key: "ATTENDEE_NAME", display: "Attendee First Name" },
    { key: "VALIDATION_LINK", display: "Magic Link" },
  ],
  FORGOT_PASSWORD: [
    { key: "ATTENDEE_NAME", display: "Attendee First Name" },
    { key: "ATTENDEE_EMAIL", display: "Attendee Email" },
    { key: "EVENT_NAME", display: "Event Name" },
    { key: "RESET_LINK", display: "Reset Link" },
  ],
  PLATFORM_FORGOT_PASSWORD: [
    { key: "FIRST_NAME", display: "First Name" },
    { key: "EMAIL", display: "Email" },
    { key: "RESET_LINK", display: "Reset Link" },
  ],
  PLATFORM_INVITE: [
    { key: "FIRST_NAME", display: "First Name" },
    { key: "ORG_NAME", display: "Org Name" },
    { key: "RESET_LINK", display: "Invite Link" },
  ],
  REG_CANCELLATION: [
    { key: "EVENT_NAME", display: "Event Name" },
    { key: "ATTENDEE_NAME", display: "Attendee First Name" },
  ],
  REFUND: [
    { key: "EVENT_NAME", display: "Event Name" },
    { key: "ATTENDEE_NAME", display: "Attendee First Name" },
    { key: "REFUND_AMOUNT", display: "Refund Amount" },
  ],
  PAYMENT_LINK: [
    { key: "EVENT_NAME", display: "Event Name" },
    { key: "ATTENDEE_NAME", display: "Attendee First Name" },
    { key: "AMOUNT_DUE", display: "Amount Due" },
    { key: "PAYMENT_URL", display: "Payment Link" },
  ],
  REG_INVITE: [
    { key: "EVENT_NAME", display: "Event Name" },
    { key: "ATTENDEE_FIRST_NAME", display: "Attendee First Name" },
    { key: "REGISTRATION_LINK", display: "Registration Link" },
  ],
  REG_EMAIL_VALIDATION: [
    { key: "VALIDATION_LINK", display: "Validation Link" },
  ],
  BROADCAST: [
    { key: "EVENT_NAME", display: "Event Name" },
    { key: "EVENT_DATE", display: "Event Date" },
    { key: "ATTENDEE_NAME", display: "Attendee First Name" },
    { key: "ATTENDEE_FULL_NAME", display: "Attendee Full Name" },
    { key: "ATTENDEE_LAST_NAME", display: "Attendee Last Name" },
    { key: "VENUE_NAME", display: "Venue Name" },
    { key: "VENUE_ADDRESS", display: "Venue Address" },
  ],
};

// Build a reverse map from display names to keys for variable replacement
const displayToKeyMap: Record<string, string> = {};
for (const variables of Object.values(EMAIL_VARIABLES_BY_TYPE)) {
  for (const v of variables) {
    displayToKeyMap[v.display] = v.key;
  }
}

export function replaceEmailVariables(
  content: string,
  replacements: Record<string, string>,
  customDisplayToKeyMap?: Record<string, string>,
): string {
  const displayMap = customDisplayToKeyMap ?? displayToKeyMap;

  // Replace {TOKEN} format — try direct key match first, then display name lookup
  let result = content.replace(/\{([^}]+)\}/g, (_match, token: string) => {
    // Direct key match (e.g. {EVENT_NAME})
    if (token in replacements) {
      return replacements[token];
    }
    // Display name lookup for backwards compatibility (e.g. {Event Name})
    const key = displayMap[token];
    if (key && key in replacements) {
      return replacements[key];
    }
    return _match;
  });

  // Replace @@KEY@@ format for backwards compatibility (e.g. @@ATTENDEE_NAME@@)
  result = result.replace(/@@(\w+)@@/g, (_match, key: string) => {
    return replacements[key] ?? _match;
  });

  return result;
}
